module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("9")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Saturday Afternoon")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("As soon as they were back in Ginger’s car, Harrie pulled out her cell phone and pushed a speed-dial number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who are you calling?” Ginger looked over at her friend before backing out of the parking space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who do you think? Our friend Cabrini.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger groaned and steered the car toward the exit. “Come on, you can’t be serious. You shouldn’t put her in that position.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie narrowed her eyes. “I need information, and she’s a likely source.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini answered on the first ring, as though already expecting a call. After a couple of minutes of idle chatter, Harrie got to the point. “I have a problem, Cabrini, and I need your help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other end of the line, Harrie heard Cabrini sigh. “Is your problem going to become my problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie put the call on speakerphone. “I hope not,” she said. “I’m here with Ginger. I put you on speaker so I don’t have to repeat the conversation for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi Ginger,” Cabrini said. “I gather she’s up to something again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just so you know,” Ginger said, “I tried to talk her out of this. It won’t surprise you to learn she wouldn’t listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other end of the line, they heard Cabrini chuckle. “Okay, what’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” Harrie said, her voice carefully noncommittal, “Ginger and I were having a discussion about police procedures, and since you’re my go-to-person for homicides and the like in Albuquerque, I thought of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not sure I like how that sounds, but I understand. What’s your question?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie outlined the events of the morning’s drone adventure. Then she explained that one of the drone pilots had found a body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other end of the line was quiet for a couple of seconds before Cabrini spoke again. Her voice sounded strained. “What sort of information are you looking for?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Harrie did a thumbs up for Ginger’s benefit. “Have they ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("identified the body found at the Petroglyphs, and can you tell me the cause of death?”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabrini didn’t speak for such an unusual interval that Harrie feared she’d lost the connection. “Cabrini, are you still there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She heard a long sigh, then Cabrini spoke into the phone in a soft voice. “This really isn’t a good time. I’m walking into a meeting as we speak. I’ll get back to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie and Ginger looked at each other. Harrie said, “Umm, okay, can you call me back when the meeting’s over?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another, shorter pause. “I have to go now. Good talking to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The call disconnected. Harrie frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, Sherlock,” Ginger said. “Now what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie put her phone back in her pocket. “Good question. I suppose I’ll play it by ear. Drop me off at my house.” She tapped her fingernails on the arm rest. Then she grinned. “This calls for strategic planning, and it’s time I brought in the big guns.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger glanced over at her friend. “And who would that be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie raised an eyebrow. “Who else? My wonderful mother-in-law who, as you so nicely reminded me, has great access to the next best source—Lieutenant Bob Swanson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gee,” Ginger said, an edge of sarcasm in her voice, “why am I not surprised?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie grinned. “I love it when a plan comes together.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0487e4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter09.vue
// module id = 96
// module chunks = 0